var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsBadgeWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40046 12.4997C0.630132 12.4997 0.149072 11.6653 0.535037 10.9986L6.13392 1.32784C6.51909 0.662552 7.47961 0.66255 7.86478 1.32783L13.4637 10.9986C13.8496 11.6653 13.3686 12.4997 12.5982 12.4997H1.40046ZM2.83846 9.66412C2.45128 10.3308 2.93226 11.1663 3.7032 11.1663H10.2955C11.0664 11.1663 11.5474 10.3308 11.1602 9.66413L7.86409 3.98864C7.47863 3.32492 6.52007 3.32492 6.13461 3.98864L2.83846 9.66412ZM6.99935 10.4997C7.18824 10.4997 7.34657 10.4358 7.47435 10.308C7.60213 10.1802 7.66602 10.0219 7.66602 9.83301C7.66602 9.64412 7.60213 9.48579 7.47435 9.35801C7.34657 9.23023 7.18824 9.16634 6.99935 9.16634C6.81046 9.16634 6.65213 9.23023 6.52435 9.35801C6.39657 9.48579 6.33268 9.64412 6.33268 9.83301C6.33268 10.0219 6.39657 10.1802 6.52435 10.308C6.65213 10.4358 6.81046 10.4997 6.99935 10.4997ZM6.33268 7.83301C6.33268 8.2012 6.63116 8.49967 6.99935 8.49967C7.36754 8.49967 7.66602 8.2012 7.66602 7.83301V5.83301C7.66602 5.46482 7.36754 5.16634 6.99935 5.16634C6.63116 5.16634 6.33268 5.46482 6.33268 5.83301V7.83301Z",
    fill: "#FFA000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBadgeWarning);
export default __webpack_public_path__ + "static/media/icons_badge_warning.adf8fa3c.svg";
export { ForwardRef as ReactComponent };